import {Breadcrumbs, BreadcrumbsLink} from '~/components/breadcrumbs';
import {Prompt} from '~/components/prompt';
import {StyledLink} from '~/components/link';

export const handle = {
  breadcrumb: () => <BreadcrumbsLink to="/rules" label="Rules" />,
};

export default function Rules() {
  return (
    <>
      <div className="w-full max-w-prose">
        <h1 className="text-5xl">Epic Rules</h1>
        <Breadcrumbs />
      </div>
      <div className="prose mb-12">
        <h2 className="text-4xl">Basics</h2>

        <p>
          A game jam is a collective or individual challenge during which
          participants are given a limited amount of time to create a video game
          from scratch. There are no losers and no winners. The main goal of a
          game jam is to bring people together, to experiment and most important
          of all, to have fun. But who knows? The experience might give birth to
          something bigger and better. Your one-shot prototype could indeed turn
          out to be the first step to an awesome project! Also, everybody can
          join!
        </p>
        <p>
          The making of a video game involves many different ingredients, these
          being visual, technical or, more generally, creative. The goal of a
          game jam is to take up a challenge and to enjoy the most of it : the
          final outcome is not that important. Therefore, whatever your
          background or level of experience, you are all warmly invited to take
          part in this adventure! Expert, newbie or amateur, the will beats the
          skills.
        </p>

        <h2 className="text-4xl">
          <span className="bg-primary text-background">Interpretation</span> of
          the main theme is{' '}
          <span className="bg-primary text-background">open</span>
        </h2>
        <p>
          The Epic Game Jam is based on one main theme that jammers have to
          integrate one way or another into their creation. If the theme can be
          recognized, perceived or experienced as such (even in a broad sense)
          by the gamers, the game is considered legit.
        </p>

        <h2 className="text-4xl">Subthemes</h2>

        <p>
          What is so special about the Epic Game Jam is that an undisclosed
          number of subthemes will be added along the way. The more subthemes
          you include in your game, the more epic points you get. Keep a close
          eye <StyledLink to="/themes">on this website</StyledLink> to be sure
          you don’t miss any of them. Whether or not you decide to embrace this
          extra challenge is completely up to you, but it sure will spice up
          your creativity!
        </p>

        <h2 className="text-4xl">
          <span className="bg-primary text-background">Feed us</span> with your
          subthemes
        </h2>

        <p>
          Well, dear jammers, YOU! Share your ideas, add them directly{' '}
          <StyledLink to="/themes/suggest">here on the website</StyledLink>. The
          main theme and all the other subthemes will then be picked by lucky
          draw.
        </p>

        <h2 className="text-4xl">Time, Tools, Formats...</h2>

        <p>
          Jammers are asked to create their game from beginning to end in the
          prescribed time (here, 45 hours). The projects, in their final
          version, have to be uploaded no later than the deadline indicated by
          the countdown timer on the website. Jammers are free to use all their
          favorite techniques, platforms, tools, languages and frameworks. If
          you are not making them yourself, please don’t forget to credit the
          creators of the scripts and assets you download in your finished game!
        </p>

        <p className="text-foreground/70">
          *We keep an open mind and love Creativity with a capital “A”. Please
          note however that we reserve ourselves the right to exclude all
          productions that are gratuitously disrespectful or offensive, or
          simply contradictory to the values that the Epic Game Jam holds at
          heart.
        </p>
      </div>

      <Prompt />
    </>
  );
}
